module.exports = __webpack_public_path__ + "media/nf_summary.7798dc54.webm";